









































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import SupplierJson from "@/doc/Supplier.json";
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import { setCommon, errorMsg } from "@/utils/request";
@Component({
  name: "system",
})
export default class CombinationProperty extends Vue {
  @Prop() questionOptions: any; // 问题类型options
  @Prop() result: any;
  @Prop() title: any;
  @Provide() private titlename: any = "";
  @Provide() private fatherinfoid: any = "";
  @Provide() private isResouceShow: any = 0;
  @Provide() private kidslist: any = "";
  @Provide() private messageData: any[] = []; // 信息关联列表
  @Provide() private selectData: any[] = []; // 被选中信息关联列表
  @Provide() private selectIds: any[] = []; // 报错时要传的被选中信息关联ID
  @Provide() private firstselect: any[] = [];
  @Provide() private parameterData: any = []; //选项列表
  @Provide() private questionList: any = []; // 问题列表赋值
  @Provide() private associatedItems: any = "";
  @Provide() private props: any = { multiple: true };
  @Provide() private msg: any = this.$message;
  @Provide() private isDisabled: any = false; // select是否可点击
  @Provide() private token: string | null = "";
  @Provide() private isSaved: any = false;
  @Provide() private radio: any = '';
  @Provide() private newQuestion: any = {
    id: "",
    qptype: "",
    value: "",
    associateditemsList: [],
    options: [],
    questionkey: "",
    // radio:''
  };
  @Provide() private currFir: any = "";

  private created() {
    this.titlename = this.title;
    this.token = localStorage.getItem("token");
    this.getQuestionAssociatedItem();
    this.getParameter();
    if (this.result.id) {
      this.isDisabled = true;
    }
  }
  private hideMsk() {
    this.hideContainer();
  }
  private editModular(value: string) {
    this.newQuestion.id = value;
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
    this.$emit("searchFormAction");
  }
  // 信息关联列表
  private async getQuestionAssociatedItem() {
    const {
      getQuestionAssociatedItemReq,
      getQuestionAssociatedItemRequest,
    }: any = await import("@/request/questionConfiguration");
    let res = await getQuestionAssociatedItemRequest.handleHttp(
      getQuestionAssociatedItemReq(),
      this
    );
    if (res && res.right) {
      res.listList.forEach((item: any) => {
        this.$set(item, "children", item.childrenList);
      });
      this.messageData = res.listList && res.listList.length > 0 ? res.listList : [];
      this.associatedItems = this.result.associateditemsList;

      let parentId: any = "";
      let beselecteds: any = [];
      // 点击编辑，信息关联回显
      this.radio = this.result.defaultnormal?"1":"2"
      
      this.result.associateditemsLisIds.forEach((item: any) => {
        this.messageData.forEach((ele: any) => {
          ele.children.map((it: any) => {
            if (item == it.value) {
              parentId = ele.value;
              beselecteds.push([parentId, item]);
            }
          });
        });
      });
      this.selectData = beselecteds;
      
      
      if (this.selectData.length > 0) {
        this.currFir = this.selectData[0][0];
      }
    }
  }
  // 单选
  // private changMessage(e: any) {   
    // ++this.isResouceShow;
    // if (!this.currFir) {
    //   this.currFir = this.selectData[0][0];
    // }
    // for (let index = 0; index < e.length; index++) {
    //   if (e[index][0] != this.currFir) {
    //     // 找到第一个不一样的第一项
    //     this.currFir = e[index][0];
    //     return (this.selectData = e.filter((it: any) => it[0] == this.currFir));
    //   }
    // }
  // }
  // 选项列表
  private async getParameter() {
    let _arg: any = {
      QpType: 10, //选项传10
    };
    const {
      getListQuestionParameterReq,
      getListQuestionParameteRequest,
    }: any = await import("@/request/questionConfiguration");
    let res = await getListQuestionParameteRequest.handleHttp(
      getListQuestionParameterReq(_arg),
      this
    );
    if (res && res.right) {
      this.parameterData = res.listList && res.listList.length > 0 ? res.listList : [];

      res.listList.forEach((element: any) => {
        let actionname = "";
        switch (element.action) {
          case 1:
            actionname = "有效";
            break;
          case 2:
            actionname = "失效";
            break;
          case 3:
            actionname = "拒贷";
            break;
          case 4:
            actionname = "无属性";
            break;
        }
        this.$set(element, "actionname", actionname);
      });

      this.newQuestion = this.result;
      if (this.result.options) {
        //选项
        this.newQuestion.options = this.result.options.split(",");
      }
    }
  }
  // 问题列表
  private async getQuestion() {
    this.newQuestion.value = "";
    let _arg: any = {
      QpType: this.newQuestion.qptype,
      status: "0",
    };
    const {
      getListQuestionParameterReq,
      getListQuestionParameteRequest,
    }: any = await import("@/request/questionConfiguration");
    let res = await getListQuestionParameteRequest.handleHttp(
      getListQuestionParameterReq(_arg),
      this
    );
    if (res && res.right) {
      this.questionList = res.listList;
    }
  }

  private submitForm() {
    let that = this;
    if (that.saveRiskReportJudgement()) {
      if (this.result.associateditemsList.length > 0) {
        this.editSaveQuestion();
      } else {
        that.saveQuestion();
      }
    } else {
      this.$message({
        type: "error",
        message: "带*号不能为空",
      });
      return false;
    } //!!
  }

  // 报存,我也不知道为啥要两个一模一样的接口，go大佬说了算
  private async saveQuestion() {
    let selectIds: any = [];
    if (this.selectData) {
      this.selectData.forEach((it: any) => {
        selectIds.push(it[1]);
      });
    }
    let verifyinfoList = {};
    let verifyinfoLists: any = [];
    selectIds.forEach((item: any) => {
      this.messageData.forEach((ele: any) => {
        ele.children.map((it: any) => {
          if (item == it.value) {
            return (verifyinfoList = {
              name: it.label,
              verifyinfoid: it.value,
            });
          }
        });
      });
      verifyinfoLists.push(verifyinfoList);
    });
    let _arg: any = {
      id: this.newQuestion.id ? this.newQuestion.id : this.newQuestion.value,
      qptype: this.newQuestion.qptype,
      value: this.newQuestion.value,
      options: this.newQuestion.options.join(","),
      associatedItemsList: verifyinfoLists,
      questionkey: this.newQuestion.questionkey,
      defaultNormal: this.radio==="1"?true:false
    };
    const { getSaveQuestionReq, getSaveQuestionRequest }: any = await import(
      "@/request/questionConfiguration"
    );
    let res = await getSaveQuestionRequest.handleHttp(getSaveQuestionReq(_arg), this);
    this.isSaved = res ? res.loading : false;
    if (res && res.right) {
      this.msg({
        type: "success",
        message: "提交成功",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    }
  }
  private async editSaveQuestion() {
    let selectIds: any = [];
    if (this.selectData) {
      this.selectData.forEach((it: any) => {
        selectIds.push(it[1]);
      });
    }
    let verifyinfoList = {};
    let verifyinfoLists: any = [];
    selectIds.forEach((item: any) => {
      this.messageData.forEach((ele: any) => {
        ele.children.map((it: any) => {
          if (item == it.value) {
            return (verifyinfoList = {
              name: it.label,
              verifyinfoid: it.value,
            });
          }
        });
      });
      verifyinfoLists.push(verifyinfoList);
    });
    let _arg: any = {
      id: this.newQuestion.id ? this.newQuestion.id : this.newQuestion.value,
      qptype: this.newQuestion.qptype,
      value: this.newQuestion.value,
      options: this.newQuestion.options.join(","),
      associatedItemsList: verifyinfoLists,
      questionkey: this.newQuestion.questionkey,
      defaultNormal:this.radio==="1"?true:false
    };
    const { getEditSaveQuestionReq, getEditSaveQuestionRequest }: any = await import(
      "@/request/questionConfiguration"
    );
    let res = await getEditSaveQuestionRequest.handleHttp(
      getEditSaveQuestionReq(_arg),
      this
    );
    this.isSaved = res ? res.loading : false;
    if (res && res.right) {
      this.msg({
        type: "success",
        message: "提交成功",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    }
  }
  private saveRiskReportJudgement() {
    if (
      this.newQuestion.qptype != "" &&
      this.newQuestion.value != "" &&
      this.newQuestion.options != "" &&
      this.selectData != []
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  // lee cancel操作
  private resetForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.closeAddDialog(false);
  }
  // lee 关闭弹窗
  private closeAddDialog(bool: boolean) {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  //返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
  private filterNode(value: string, data: any) {
    if (!value) return true;
    return data.name.indexOf(value) !== -1;
  }
}
